import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./Components/Css/PaymentLedger1.css";
import Add_Faqs from "./Components/Add_Faqs";
import AddAgent from "./Components/AddAgent";
import AddCarDetailNew from "./Components/AddCarDetailNew";
import AddCarDetails from "./Components/AddCarDetails";
import AddDesignation from "./Components/AddDesignation";
import AddStaff from "./Components/AddStaff";
import AddTestimonial from "./Components/AddTestimonial";
import Analytics from "./Components/Analytics";
import CarFaqAdd from "./Components/CarFaqAdd";
import CarFaqView from "./Components/CarFaqView";
import CarModelAdd from "./Components/CarModelAdd";
import CarModelView from "./Components/CarModelView";
import ChangePassword from "./Components/ChangePassword";
import CreateInsidePageRights from "./Components/CreateInsidePageRights";
import CreateReservation from "./Components/CreateReservation";
import CreateStaffRights from "./Components/CreateStaffRights";
import CreateSubStaffRights from "./Components/CreateSubStaffRights";
import "./Components/Css/Maintanance.css";
import EditSubRights from "./Components/EditSubRights";
import ForgotPassword from "./Components/ForgotPassword";
import GuestMngmt from "./Components/GuestMngmt";
import InsidePageRightsView from "./Components/InsidePageRightsView";
import Login from "./Components/Login";
import MaintananceFormSave from "./Components/Maintanance Form/MaintananceFormSave";
import MaintananceFormEdit from "./Components/Maintanance Form/MaintananceFormEdit";
import MaintenanceDetails from "./Components/MaintenanceDetails";
import MaintenanceDetailsPrice from "./Components/MaintenanceDetailsPrice";
import Manuals from "./Components/Manuals";
import MyUserData from "./Components/MyUserData";
import PrintEnqury from "./Components/PrintEnqury";
import ProfileSettings from "./Components/ProfileSettings";
import Report from "./Components/Reports";
import ViewAgent from "./Components/ViewAgent";
import ViewCardetails from "./Components/ViewCardetails";
import ViewDesignation from "./Components/ViewDesignation";
import ViewFaq from "./Components/ViewFaq";
import ViewMaintenance from "./Components/ViewMaintenance";
import ViewReservationCalendar from "./Components/ViewReservationCalendar";
import ViewStaff from "./Components/ViewStaff";
import ViewStaffRights from "./Components/ViewStaffRights";
import ViewSubRights from "./Components/ViewSubRights";
import ViewTestimonial from "./Components/ViewTestimonial";
import WebsiteMngt from "./Components/WebsiteMngmt";
import MaintananceViewPage from "./Components/MaintananceViewPage";
import MaintananceLog from "./Components/MaintananceLog";
import ViewAgreeMentForm from "./Components/ViewAgreeMentForm";
import EditApplicationFormPage from "./Components/EditApplicationFormPage";
import InsuranceForm from "./Components/InsuranceForm";
import ViewMaintanceForm from "./Components/ViewMaintanceForm";
import PickUpForm from "./Components/PickUpForm";
import DropOfForm from "./Components/DropOfForm";
import DropFormPDF from "./Components/DropFormPDF";
import PickupFormPreview from "./Components/PickupFormPreview";
import DropoffFormPreview from "./Components/DropoffFormPreview";
import PickUpFormPDF from "./Components/PickUpFormPDF";
import WeeklyReport from "./Components/WeeklyReport";
import ViewCustomer from "./Components/ViewCustomer";
import CarFeatures from "./Components/CarFeatures";
import "react-datepicker/dist/react-datepicker.css";
import PaymentDashboard from "./Components/Payment.js/PaymentDashboard";
import PaymentLedger from "./Components/Payment.js/PaymentLedger";
import Repo from "./Components/Repo";
import CustomerHistory from "./Components/CustomerHistory";
import DriverReport from "./Components/Payment.js/DriverReport";
import DriverAllReports from "./Components/Payment.js/DriverAllReports";
import ViewRepo from "./Components/ViewRepo";
import PaymentModule from "./Components/AccountingModule/PaymentModule";
import ManageIPasses from "./Components/ManageIPasses";
import AddKB from "./Components/AddKB";
import ViewKB from "./Components/ViewKB";
import { BreadcrumbProvider } from "./CommonJquery/BreadcrumbProvider";
import BookingsReport from "./Components/BookingsReport";
import Lead_Managment from "./Components/Lead_Managment";
import MaintananceReport from "./Components/MaintananceReport";
import ACREnquiries from "./Components/ACREnquiries";
import CarsReport from "./Components/CarsReport";
import ViewRepair from "./Components/ViewRepair";
import RepairLog from "./Components/RepairLog";
import RepairFormSave from "./Components/Maintanance Form/RepairFormSave";
import UnassignedTolls from "./Components/UnassignedTolls";
import TollExceptions from "./Components/TollExceptions";
import { ToastContainer } from "react-toastify";
import ViewServiceCharge from "./Components/AccountingModule/ViewServiceCharge";
import OfficeUseTolls from "./Components/OfficeUseTolls";
import OilCheckFormSave from "./Components/Maintanance Form/OilCheckFormSave";
import OilCheckLog from "./Components/OilCheckLog";
import ViewOilCheck from "./Components/ViewOilCheck";
import ViewNewGuestCar from "./Components/ViewNewGuestCar";
function App() {
  useEffect(() => {
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, [Array]);
  // const dummyRepoData = {
  //   repo_id: "REPO-2025-0042",
  //   booking_id: "BK-12345",
  //   car_id: "CAR-789456",
  //   user_id: "USR-56789",
  //   created_at: "2025-04-24T14:30:00",
  //   key_image: "/api/placeholder/400/300",
  //   gas_level: 7,
  //   front_left_car_images: "/api/placeholder/400/300",
  //   front_right_car_images: "/api/placeholder/400/300",
  //   back_left_car_images: "/api/placeholder/400/300",
  //   back_right_car_images: "/api/placeholder/400/300",
  //   notes: "Vehicle returned in good condition. Minor scratch noted on rear bumper. Interior was cleaned by customer. All documentation properly submitted at time of return."
  // };

  return (
    <div className="App">
      <BrowserRouter>
        <BreadcrumbProvider>
          <Routes>
            {/* Working Screen */}

            {/* Login Screens */}
            <Route path="/" element={<Login />} />
            <Route path="/Forgot_Password" element={<ForgotPassword />} />
            <Route path="/Change_Password/:id" element={<ChangePassword />} />

            {/* Add and Edit Staff Pages */}
            <Route path="/View_Staff" element={<ViewStaff />} />
            <Route path="/Add_Staff" element={<AddStaff />} />
            <Route path="/edit_staff/:id" element={<AddStaff />} />
            <Route path="/Add_KB" element={<AddKB />} />
            <Route path="/Edit_KB/:id" element={<AddKB />} />
            <Route path="/View_KB" element={<ViewKB />} />

            {/* Profile Settings Pages */}
            <Route path="/Profile_Settings" element={<ProfileSettings />} />

            {/* Guest Management Pages */}
            <Route path="/Enquiries" element={<GuestMngmt />} />

            {/* Floor Management Pages */}

            <Route path="/Bookings" element={<ViewReservationCalendar />} />
            <Route path="/Car_Types" element={<CarModelView />} />
            <Route path="/Add_Car_Type" element={<CarModelAdd />} />
            <Route path="/Edit_carmodel/:id" element={<CarModelAdd />} />
            {/* Restraurant Setup Pages */}

            {/* System Settings Pages */}
            {/* Website Settings Pages */}
            <Route path="/Website_Management" element={<WebsiteMngt />} />

            {/* Create, Edit and View Righst Pages */}
            <Route
              path="/Create_Staff_Rights"
              element={<CreateStaffRights />}
            />
            <Route path="/View_Staff_Rights" element={<ViewStaffRights />} />
            <Route
              path="/Edit_Staff_Rights/:id"
              element={<CreateStaffRights />}
            />
            <Route
              path="/Create_SubStaff_Rights/:id"
              element={<CreateSubStaffRights />}
            />
            <Route path="/View_Sub_Rights/:id" element={<ViewSubRights />} />
            <Route
              path="/Edit_SubStaff_Rights/:id"
              element={<CreateSubStaffRights />}
            />
            <Route path="/Edit_Sub_Rights" element={<EditSubRights />} />
            <Route
              path="/View_Inside_Page_Rights/:id"
              element={<InsidePageRightsView />}
            />
            <Route
              path="/Create_Inside_Page_Rights/:id"
              element={<CreateInsidePageRights />}
            />
            <Route path="/view_cardetails" element={<ViewCardetails />} />
            <Route path="/view_new_guest_cars" element={<ViewNewGuestCar />} />
            <Route path="/add_cardetails" element={<AddCarDetails />} />
            <Route path="/edit_cardetails/:id" element={<AddCarDetails />} />
            <Route path="/Add_Designation" element={<AddDesignation />} />
            <Route path="/Edit_Designation/:id" element={<AddDesignation />} />
            <Route path="/ViewDesignation" element={<ViewDesignation />} />

            <Route path="/Create_Reservation" element={<CreateReservation />} />
            <Route
              path="/Edit_Reservation/:reservation_id"
              element={<CreateReservation />}
            />
            <Route path="/Create_WalkIn" element={<CreateReservation />} />
            <Route
              path="/Create_WalkInSwitch/:reservation_id"
              element={<CreateReservation />}
            />

            {/* Help And Support Pages */}
            <Route path="/Manuals" element={<Manuals />} />
            <Route path="/Add_Faq" element={<Add_Faqs />} />
            <Route path="/View_Faq" element={<ViewFaq />} />

            <Route path="/Edit_Faq/:id" element={<Add_Faqs />} />

            {/* Analytics and Reports Pages */}
            <Route path="/Dashboard" element={<Analytics />} />

            <Route path="/Customers" element={<MyUserData />} />
            <Route path="/Booking_Reports" element={<BookingsReport />} />
            <Route
              path="/Maintanance_Reports"
              element={<MaintananceReport />}
            />
            <Route path="/Cars_Reports" element={<CarsReport />} />
            <Route path="/View_Reports" element={<Report />} />
            <Route path="/View_Testimonial" element={<ViewTestimonial />} />
            <Route path="/Add_Testimonial" element={<AddTestimonial />} />
            <Route path="/Edit_Testimonial/:id" element={<AddTestimonial />} />

            <Route path="/View_carfaq/:id" element={<CarFaqView />} />
            <Route path="/Add_carfaq/:id" element={<CarFaqAdd />} />
            <Route path="/Edit_carfaq/:id" element={<CarFaqAdd />} />

            <Route path="/View_agent" element={<ViewAgent />} />
            <Route path="/Add_agent" element={<AddAgent />} />
            <Route path="/PrintEnqury" element={<PrintEnqury />} />
            <Route path="/AddCarDetailNew" element={<AddCarDetailNew />} />
            <Route path="/EditCarDetailNew/:id" element={<AddCarDetailNew />} />
            <Route path="/view_car_detail/:id" element={<AddCarDetailNew />} />
            <Route path="/ViewMaintenance/:id" element={<ViewMaintenance />} />
            <Route path="/Edit_agent/:id" element={<AddAgent />} />
            <Route
              path="/mainatanance_form/:id"
              element={<MaintananceFormSave />}
            />
            <Route path="/repair_form/:id" element={<RepairFormSave />} />
            <Route path="/oil_check_form/:id" element={<OilCheckFormSave />} />
            <Route
              path="/mainatanance_form_edit/:id/:id2"
              element={<MaintananceFormEdit />}
            />
            <Route path="/Maintanance" element={<MaintananceViewPage />} />

            <Route
              path="/ViewApplicationForm"
              element={<ViewAgreeMentForm />}
            />
            <Route path="/InsuranceForm" element={<InsuranceForm />} />
            <Route
              path="/Edit_application/:id"
              element={<EditApplicationFormPage />}
            />
            <Route
              path="/car_maintenance_logs/:id"
              element={<MaintananceLog />}
            />
            <Route path="/RepairLog/:id" element={<RepairLog />} />
            <Route path="/OilCheckLog/:id" element={<OilCheckLog />} />
            <Route
              path="/view_maintenance_form"
              element={<ViewMaintanceForm />}
            />
            <Route path="/PickUpForm/:id" element={<PickUpForm />} />
            <Route path="/DropOfForm/:id" element={<DropOfForm />} />
            <Route path="/SwitchForm/:id" element={<DropOfForm />} />

            <Route path="/DropFormPDF" element={<DropFormPDF />} />
            <Route path="/PickupFormPreview" element={<PickupFormPreview />} />
            <Route
              path="/DropoffFormPreview"
              element={<DropoffFormPreview />}
            />
            <Route path="/PickUpFormPDF" element={<PickUpFormPDF />} />
            <Route path="/WeeklyReport" element={<WeeklyReport />} />
            <Route path="/CarFeatures" element={<CarFeatures />} />
            <Route path="/view_customer/:id" element={<ViewCustomer />} />

            <Route
              path="/maintenance_details/:id"
              element={<MaintenanceDetails />}
            />
            <Route
              path="/maintenance_details_price/:id"
              element={<MaintenanceDetailsPrice />}
            />

            <Route path="/payment-dashboard" element={<PaymentDashboard />} />
            <Route path="/payment-reports" element={<DriverReport />} />
            <Route
              path="/driver-all-reports/:id"
              element={<DriverAllReports />}
            />
            <Route path="/Repo-Form" element={<Repo />} />
            <Route path="/Customer-history/:id" element={<CustomerHistory />} />
            <Route path="/ViewRepo" element={<ViewRepo />} />
            <Route path="/payment-ledger" element={<PaymentModule />} />
            <Route path="/Manage-Ipass" element={<ManageIPasses />} />
            <Route path="/Unassigned_Tolls" element={<UnassignedTolls />} />
            <Route path="/officeUse_Tolls" element={<OfficeUseTolls />} />
            <Route path="/Exception_Tolls" element={<TollExceptions />} />
            <Route path="/Lead_Managment" element={<Lead_Managment />} />
            <Route path="/RepairLog" element={<RepairLog />} />
            <Route path="/ViewRepair" element={<ViewRepair />} />
            <Route path="/ViewOilCheck" element={<ViewOilCheck />} />
            <Route path="/acr_enquiries" element={<ACREnquiries />} />
            <Route
              path="/View-Service-Charge"
              element={<ViewServiceCharge />}
            />
          </Routes>
        </BreadcrumbProvider>
      </BrowserRouter>
      <ToastContainer toastStyle={{ zIndex: 9999 }} />
    </div>
  );
}

export default App;
